"use client";

import React, { FunctionComponent, useEffect, useState } from "react";
import Image from "next/image";
import {
  IPropertySearch,
  IPropertySearchFields,
} from "@/types/generated/contentful";
import { Search } from "@sponsorpulse/atoms";
import Link from "next/link";

type Props = {
  content: IPropertySearch;
};

const PropertySearch: FunctionComponent<Props> = ({ content }) => {
  const { heading, background, foreground } =
    content.fields as IPropertySearchFields;
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    const getProperties = async () => {
      fetch("/api/properties")
        .then((res) => res.json())
        .then((data) => {
          setProperties(data);
        })
        .catch(() => {
          setProperties([]);
        });
    };
    getProperties();
  }, []);

  const resultComponent = (item: any) => {
    const option = item.option;
    return (
      <Link href={`/properties/${option.slug}`}>
        <div className="group flex flex-row items-center gap-2 p-2 text-base text-sp-dark-purple">
          <div className="relative h-8 w-8">
            <Image
              src={`${process.env.NEXT_PUBLIC_CDN_URL}/property-images/${option.value}.png`}
              alt={option.name}
              layout="fill"
              style={{
                objectFit: "contain",
              }}
            />
          </div>
          <div className="flex-1">{option.name}</div>
        </div>
      </Link>
    );
  };

  return (
    <div
      className="grid grid-cols-1 gap-4 rounded-lg p-8 md:grid-cols-5 md:items-center"
      style={{
        backgroundColor: background || "transparent",
        ...(foreground && { color: foreground }),
      }}
    >
      <label
        className="whitespace-nowrap text-lg md:col-span-2 md:text-right md:text-xl"
        htmlFor="property-search"
      >
        {heading}
      </label>
      <div className="md:col-span-3 xl:col-span-2">
        <Search
          name="property-search"
          searchableItems={properties}
          searchKeys={["name"]}
          placeholder=""
          resultComponent={resultComponent}
          menuClassName="-mt-8 max-h-36"
        />
      </div>
    </div>
  );
};

export default PropertySearch;
